"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/ConsentTab/TurnOnModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _consent = require('shared/services/consent');
var _smsDelivery = require('shared/services/smsDelivery');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);








const CONSENT_TURN_ON_TITLE = 'Require consent before texting?'



// The admin picks what happens to existing contacts: count the ones texted in
// the last 12 months (with an attestation the server records), or ask
// everyone. "Turn on" waits for the attestation.
const TurnOnModal = ({ isOpen, orgKey, onClose, onTurnedOn }) => {
  const [counts, setCounts] = _react.useState(null)
  const [hasCountsFailed, setHasCountsFailed] = _react.useState.call(void 0, false)
  const [mode, setMode] = _react.useState('count_recent')
  const [isAttested, setIsAttested] = _react.useState.call(void 0, false)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [saveError, setSaveError] = _react.useState(null)

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return undefined
    let isCurrent = true
    setCounts(null)
    setHasCountsFailed(false)
    setMode('count_recent')
    setIsAttested(false)
    setSaveError(null)
    _actions2.default.getConsentTurnOnCounts({ OrgKey: orgKey })
      .then(c => { if (isCurrent) setCounts(c) })
      .catch(() => { if (isCurrent) setHasCountsFailed(true) })
    return () => { isCurrent = false }
  }, [isOpen, orgKey])

  const copy = _react.useMemo.call(void 0, () => counts && _consent.makeConsentTurnOnCopy.call(void 0, counts), [counts])

  const onPickCountRecent = _react.useCallback.call(void 0, () => { setMode('count_recent'); setSaveError(null) }, [])
  const onPickAskEveryone = _react.useCallback.call(void 0, () => { setMode('ask_everyone'); setSaveError(null) }, [])
  const onAttestChange = _react.useCallback.call(void 0, (e) => {
    setIsAttested(e.target.checked)
    setSaveError(null)
  }, [])

  const turnOn = _react.useCallback.call(void 0, () => {
    setIsSaving(true)
    setSaveError(null)
    _actions2.default.turnOnOrgConsent({ OrgKey: orgKey, Mode: mode, Attested: mode === 'count_recent' && isAttested })
      .then(onTurnedOn)
      .catch(e => setSaveError(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Couldn\'t turn this on. Try again.')))
      .finally(() => setIsSaving(false))
  }, [orgKey, mode, isAttested, onTurnedOn])

  const groupId = _react.useId.call(void 0, )
  // Counting recent contacts needs the counts (the attestation names them).
  const canTurnOn = !isSaving && (mode === 'ask_everyone' || (!!counts && isAttested))

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: CONSENT_TURN_ON_TITLE, className: "consent-turn-on-modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}, "From now on, the first text to a contact without consent goes out as the consent request. Your team's messages wait in the chat and send when the contact replies YES."


      )
      , _react2.default.createElement('h4', { id: groupId, className: "consent-turn-on-modal--question", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
        ,  _nullishCoalesce(_optionalChain([copy, 'optionalAccess', _ => _.question]), () => ( 'What about your existing contacts?')) 
      )
      ,  !counts && !hasCountsFailed && (
        _react2.default.createElement('span', { className: "consent-turn-on-modal--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Counting your contacts…"  )
      )
      ,  hasCountsFailed && (
        _react2.default.createElement('span', { role: "alert", className: "consent-turn-on-modal--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}, "Couldn't count your contacts. Close this and try again, or choose Ask everyone."

        )
      )
      , _react2.default.createElement('div', { role: "radiogroup", 'aria-labelledby': groupId, className: "consent-turn-on-modal--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
        , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'consent-turn-on-modal--option', mode === 'count_recent' && 'consent-turn-on-modal--option--selected'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
          , _react2.default.createElement('label', { className: "consent-turn-on-modal--option-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
            , _react2.default.createElement('input', {
              type: "radio",
              name: "consent-turn-on-mode",
              checked: mode === 'count_recent',
              onChange: onPickCountRecent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
            )
            , _react2.default.createElement('span', { className: "consent-turn-on-modal--option-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, "Count recent contacts as consented"    )
          )
          ,  copy && _react2.default.createElement('span', { className: "consent-turn-on-modal--option-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}},  copy.countRecent ) 
          ,  copy && mode === 'count_recent' && (
            _react2.default.createElement('label', { className: "consent-turn-on-modal--attest", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
              , _react2.default.createElement('input', { type: "checkbox", checked: isAttested, onChange: onAttestChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}} )
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
                , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 103}},  copy.attestation )
                ,  ' ' 
                , _react2.default.createElement('span', { className: "consent-turn-on-modal--attest-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}, "BloomText records your name and the time."      )
              )
            )
          )
        )
        , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'consent-turn-on-modal--option', mode === 'ask_everyone' && 'consent-turn-on-modal--option--selected'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
          , _react2.default.createElement('label', { className: "consent-turn-on-modal--option-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
            , _react2.default.createElement('input', {
              type: "radio",
              name: "consent-turn-on-mode",
              checked: mode === 'ask_everyone',
              onChange: onPickAskEveryone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
            )
            , _react2.default.createElement('span', { className: "consent-turn-on-modal--option-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}, "Ask everyone" )
          )
          , _react2.default.createElement('span', { className: "consent-turn-on-modal--option-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
            ,  _nullishCoalesce(_optionalChain([copy, 'optionalAccess', _2 => _2.askEveryone]), () => ( 'Every contact gets the consent request the next time your team texts them.')) 
          )
        )
      )
      , _react2.default.createElement('span', { className: "consent-turn-on-modal--footnote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}, "Contacts who texted STOP stay opted out either way."        )
      ,  saveError && _react2.default.createElement('span', { role: "alert", className: "consent-turn-on-modal--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}},  saveError ) 
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Turn on" ,
        secondaryBtnLabel: "Cancel",
        isPrimaryLoading: isSaving,
        isPrimaryEnabled: canTurnOn,
        onPrimaryBtnClick: turnOn,
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}
      )
    )
  )
}

exports. default = TurnOnModal
